import { FunctionComponent, useMemo } from "react";
import { Tooltip } from "../../../tooltip";
import { faTranslate2 } from "@awesome.me/kit-67bf90e9a4/icons/kit/custom";
import { ActionIcon } from "../../../action-icon";
import { Text } from "../../../text";
import { useInteractionModalContext } from "../hooks";

/**
 * Button component used to translate the interaction and show the ISO code of the language shown.
 * @returns The translate button
 */
export const TranslateButton: FunctionComponent = () => {
    const { interactionDetails, user, actions } = useInteractionModalContext();

    const locale = useMemo(() => (navigator.language === "en-US" ? "en-US" : "en-GB"), []);

    const originalLanguage = useMemo(() => {
        const languageCode = interactionDetails?.data?.languageIsoCode ?? "";
        // Handle the custom "un" (unknown) language code from backend
        if (languageCode.toLowerCase() === "un") {
            return "Unknown";
        }
        const languageNames = new Intl.DisplayNames(locale, { type: "language" });
        try {
            return languageNames.of(languageCode);
        } catch {
            return languageCode;
        }
    }, [interactionDetails?.data?.languageIsoCode, locale]);

    return (
        <>
            {user?.data?.languageIsoCode && interactionDetails?.data?.languageIsoCode && (
                <Text size="sm" variant="medium" dimmed>
                    {actions?.translation?.isEnabled
                        ? user?.data?.languageIsoCode.toLocaleUpperCase()
                        : interactionDetails?.data?.languageIsoCode.toLocaleUpperCase()}
                </Text>
            )}
            <Tooltip
                label={
                    actions?.translation?.isEnabled
                        ? `See Original (${originalLanguage})`
                        : `Translate from ${originalLanguage}`
                }
            >
                <ActionIcon.Toggle
                    data-testid="translation-button"
                    enabled={actions?.translation?.isEnabled}
                    onClick={actions?.translation?.onToggle}
                    disabled={actions?.translation?.isDisabled}
                    size="input-xs"
                    icon={faTranslate2}
                />
            </Tooltip>
        </>
    );
};
